<template>
    <div class="login-background">
        <v-container>
            <v-row class="logorow my-16" align="center" justify="center">
                <v-img class="logo mt-md-16 mt-sm-4" :src="iconUrl"></v-img>
            </v-row>
            <v-row justify="center" align="center">
                <h1 v-if="!isLoginFailed" class="base-header mt-16">
                    Login
                </h1>
                <div v-else>
                    <h1 class="error-header mt-16" align="center">
                        Login failed.
                    </h1>
                    <h2 class="error-header-password" align="center">
                        Incorrect email or password.
                    </h2>
                </div>
            </v-row>
            <v-row>
                <v-container class="fill-height" fluid>
                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="6" md="6">
                            <v-card class="elevation-12 rounded login-card mt-4">
                                <v-card-text>
                                    <v-form ref="form" @submit.prevent="checkValidation">
                                        <v-text-field
                                            color="teal"
                                            class="mt-6"
                                            v-model="login.email"
                                            label="E-mail*"
                                            outlined
                                            dense
                                            prepend-icon="mdi-account-circle"
                                            :rules="emailRules"
                                        ></v-text-field>
                                        <v-text-field
                                            color="teal"
                                            v-model="login.password"
                                            :append-icon="passwordIconName"
                                            :type="passwordType"
                                            name="input-10-1"
                                            label="Password*"
                                            prepend-icon="mdi-lock"
                                            hint="At least 8 characters"
                                            outlined
                                            dense
                                            @click:append="isPasswordShown = !isPasswordShown"
                                            :rules="passwordRules"
                                        />

                                        <v-divider></v-divider>
                                        <v-row>
                                            <v-checkbox class="mt-0 ml-3" v-model="isRememberMeChecked" label="Remember me"></v-checkbox>
                                        </v-row>
                                        <v-card-actions class="justify-center">
                                            <v-btn :disabled="!$online" width="100%" height="42px" class="btn-register mb-4" color="teal" type="submit">Login</v-btn>
                                        </v-card-actions>
                                        <v-card-actions class="justify-center">
                                            <v-btn :disabled="!$online" width="100%" @click="signInWithGoogle" height="42px" class="btn-register mb-4" color="success">{{
                                                $online ? 'Sign in with google' : 'you are offline'
                                            }}</v-btn>
                                        </v-card-actions>
                                    </v-form>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
        </v-container>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { VueReCaptcha } from 'vue-recaptcha-v3';

    import { mapActions, mapGetters } from 'vuex';

    export default {
        data() {
            return {
                isPasswordShown: false,
                login: {
                    email: '',
                    password: '',
                },
                isRememberMeChecked: false,
                emailRules: [],
                passwordRules: [],
                isLoginFailed: false,
                iconUrl: 'https://www.webgurus.biz/wp-content/uploads/2018/03/logo_webgurus@2x.png',
            };
        },

        computed: {
            passwordType() {
                return this.isPasswordShown ? 'text' : 'password';
            },
            passwordIconName() {
                return this.isPasswordShown ? 'mdi-eye' : 'mdi-eye-off';
            },
        },

        watch: {
            'login.email'() {
                this.emailRules = [];
            },
            'login.password'() {
                this.passwordRules = [];
            },
        },
        mounted() {
            VueReCaptcha(Vue, { siteKey: '6LeUkO8ZAAAAADadfdueEaH9uF4GoH2_MokJurQ9' });
            this.getLocalStorageEmail();
        },
        methods: {
            setEmailInLocalStorage() {
                if (this.isRememberMeChecked) {
                    localStorage.email = this.login.email;
                }
            },

            getLocalStorageEmail() {
                if (localStorage.email) {
                    this.login.email = localStorage.email;
                }
            },

            ...mapActions(['login/', 'fetchUser']),
            ...mapActions(['login/', 'setLoggedInState']),

            loginClick() {
                this.fetchUser(this.login)
                    .then((result) => {
                        this.$router.push({
                            name: 'FormPage',
                        });
                    })
                    .catch(() => {
                        this.isLoginFailed = true;
                    });
            },

            checkValidation() {
                this.emailRules = [(value) => !!value || 'E-mail mező kitöltése kötelező!', (value) => /.+@.+/.test(value) || 'Helytelen e-mail formátum!'];
                this.passwordRules = [(value) => !!value || 'Jelszó mező kitöltése kötelező!'];
                this.$nextTick(() => {
                    if (this.$refs.form.validate()) {
                        this.setEmailInLocalStorage();
                        this.loginClick();
                    }
                });
            },
            signInWithGoogle() {
                window.location = `https://liquidity-dev.webgurus.biz/login/google`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    #loginbtn {
        width: 250px;
        position: absolute;
    }
    .logo {
        position: absolute;
        width: 130px;
        height: 130px;
    }
    .login-card {
        position: relative;
        background: #ffffff !important ;
        box-shadow: 2px 1px 10px rgba(205, 205, 212, 0.1) !important;
        border-radius: 5px;
        filter: drop-shadow(2px 1px 10px rgba(162, 162, 162, 0.25));
    }
    .base-header {
        position: relative;
        font-family: Bariol;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 26px;
        letter-spacing: 0.1px;

        color: #000000;
    }

    .error-header {
        font-family: Bariol;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 26px;
        letter-spacing: 0.1px;

        color: red;
    }
    .error-header-password {
        font-family: Bariol;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 26px;
        letter-spacing: 0.1px;

        color: red;
    }
</style>
